import { IConsentModel } from "../../models/consent.model";

export const blueMediaConsents: IConsentModel[] = [ //HACK: skopany kod !!! dane powinny byc pobrane z mongodb !!!
  {
    id: "327",
    isConsent: true,
    text: "Akceptuję Regulamin usługi dostępu do skonsolidowanych informacji o rachunku oraz Politykę prywatności Blue Media S.A. Zgadzam się na świadczenie przez Blue Media S.A. usługi dostępu do skonsolidowanych informacji o rachunku oraz pobranie historii transakcji z rachunku za okres ostatnich 180 dni."
  },
  {
    id: "328",
    isConsent: true,
    text: "Zgadzam się na udostępnienie przez Blue Media S.A. danych pobranych z rachunku bankowego (w tym danych objętych tajemnicą płatniczą oraz danych osobowych dotyczących ewentualnego współposiadacza rachunku płatniczego) do Paytree SA z siedzibą w Gdańsku, przy ul. Chłopska 53 (Odbiorca). Przyjmuję do wiadomości, że zasady przetwarzania moich danych przez Paytree SA znajdują się na stronie https://payka.pl/prywatnosc"
  }
]